<template>
  <div
    class="app-container"
    v-loading="openloading"
    element-loading-text="加载中"
    element-loading-background="rgba(0, 0, 0, 0.1)"
  >
    <el-row style="padding-bottom: 15px;">
      <el-col :span="24">
        <h3 class="headtitle">单据管理</h3>
      </el-col>
    </el-row>
    <el-tabs type="border-card" v-model="activetab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :label="tab.moduleName"
        :key="index"
        :name="tab.moduleType"
        @click="toggleTabs(tab.moduleType);"
      >
        <component
          :is="tab.moduleType"
          :tabType="tab.moduleType"
          keep-alive
          :openloading="openloadingHandler"
          :closeloading="closeloadingHandler"
        ></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
import orderPos from "@/views/orderAdmin/orderManagerPos";
import orderCloud from "@/views/orderAdmin/orderManagerCloud";
import orderCrm from "@/views/orderAdmin/orderManagerCrm";
export default {
  components: {
    orderPos,
    orderCloud,
    orderCrm
  },
  data() {
    return {
      openloading: false,
      orderPos: "orderPos", //导航栏文本1
      orderCloud: "orderCloud", //导航栏文本2
      orderCrm: "orderCrm",
      currentView: "", //默认选中first子组件
      activetab: "",
      orderCreateApi: config.BASE_Middle_API + "orderCreate",
      tabList: []
    };
  },
  mounted() {
    this.getSysModules();
  },
  methods: {
    openloadingHandler() {
      this.openloading = true;
    },
    closeloadingHandler() {
      this.openloading = false;
    },
    toggleTabs(tab) {
      this.currentView = tab;
    },
    getSysModules() {
      const _this = this;
      _this.openloading = true;
      AjaxHelper.get(_this.orderCreateApi + "/getSysModules")
        .then(function(response) {
          if (response.success) {
            _this.tabList = response.result;
            _this.activetab = _this.tabList[0].moduleType;
            _this.currentView = _this.tabList[0].moduleType;
          }
          _this.openloading = false;
        })
        .catch(function(error) {
          _this.openloading = false;
        });
    }
  }
};
</script>

<style scoped>
nav {
  width: 600px;
  /* background: #eeeeee; */
  padding: 0 0px;
}
nav .active {
  background-color: #409eff;
  color: #fff;
}
nav a {
  text-decoration: none;
  color: rgb(0, 0, 0);
  display: inline-block;
  width: 150px;
  border-radius: 5px;
  text-align: center;
  /* background: #fdfcfc; */
  padding: 10px;
  margin-bottom: 15px;
}
.el-tabs--border-card > .el-tabs__content {
  padding: 0 !important ;
}
</style>